/**
 * Default only applied to SVG's which do not have height and width.
 *
 * Fix planned in ticket https://linear.app/prismic/issue/PBD-926/apply-a-default-height-and-width-for-an-svg
 *
 * This will add a default height and width which is more accurate in the BE.
 */

export const defaultImageDimension = 2000
